export interface Topic {
  key: string;
  name: string;
  color: string;
  description: string;
  active: boolean;
  hashtags: string[]; // topic-specific hashtags, always included for this topic
}

export const DEFAULT_TOPICS: Topic[] = [
  {
    key: 'immogen', name: 'Immogen', color: '#a78bfa',
    description: 'Österreichischer AI-Exposé-Generator für Makler',
    active: true,
    hashtags: ['#Immogen', '#Proptech', '#AIRealEstate'],
  },
  {
    key: 'drip', name: 'DRIP DECK', color: '#f87171',
    description: 'AI-powered digital wardrobe app',
    active: true,
    hashtags: ['#DripDeck', '#AIFashion', '#WardrobeAI'],
  },
  {
    key: 'stonewave', name: 'Stonewave Tech', color: '#00D2FF',
    description: 'Company brand, tech forge identity',
    active: true,
    hashtags: ['#StonewaveTech', '#SoftwareForge', '#AustrianStartup'],
  },
  {
    key: 'ai', name: 'AI Unpacked', color: '#34d399',
    description: 'AI-Trends eingeordnet für Gründer',
    active: true,
    hashtags: ['#AIUnpacked', '#ArtificialIntelligence', '#AITrends'],
  },
  {
    key: 'orbit', name: 'Nordstein Orbit', color: '#fb923c',
    description: 'AI-native sales OS für Outreach-Agenturen',
    active: true,
    hashtags: ['#NordsteinOrbit', '#SalesAI', '#OutreachAutomation'],
  },
];
